import { theme } from "uikit";
import { isArray } from "lodash";

import Order, {
	OrderReminderStatus,
} from "../../../../../../../services/Order";

const backgroundColorByStatus = {
	offer: "#51C3F7",
	executing: "rgb(76, 175, 80)",
	inactive: "#ebebeb",
	send: "#FFA500",
	dispatcherBGC: theme.colors.disabled_text,
	dispatcherText: theme.colors.white,
};

const cellProcessing = (
	item: Order.Model,
): {
	content: string;
	backgroundColor?: string;
	textColor?: string;
} => {
	const lastReceivedOrder =
		item?.additionalFields?.transfer?.lastReceivedOrder;

	const executorsFromTransfer: any[] = isArray(
		lastReceivedOrder?.executorToOrder,
	)
		? lastReceivedOrder?.executorToOrder ?? []
		: [];

	const executorFromTransfer =
		lastReceivedOrder?.executorToOrder?.[0]?.executor ??
		lastReceivedOrder?.offer?.executor;

	const executor =
		item?.executorToOrder?.[0]?.executor ?? item.offer?.executor;

	const isOwn = item?.isOwn;

	const content =
		isOwn && executorFromTransfer ? "" : executor?.callSign ?? "";

	const isDispatcher = item.executorToOrder?.some(
		(e) =>
			e.executor.id === executor?.id &&
			e.additionalFields?.acceptedByDispatcher?.active,
	);

	const isDispatcherFrom = executorsFromTransfer.some(
		(e) =>
			e.executor?.id === executorFromTransfer?.id &&
			e.additionalFields?.acceptedByDispatcher?.active,
	);

	let backgroundColor: string | undefined;

	if (lastReceivedOrder && isOwn && executorFromTransfer) {
		// Возможное использование дополнительных условий:
		// return undefined;
		backgroundColor = undefined;
	} else if (
		item.executorReminderStatus?.status === OrderReminderStatus.SEND
	) {
		backgroundColor = backgroundColorByStatus.send;
	} else if (item.executingStages?.accepted) {
		backgroundColor = backgroundColorByStatus.executing;
	} else if (
		isDispatcher &&
		(item.executingStages?.assigned || !item?.offer?.executor?.online) &&
		!item.executingStages?.accepted
	) {
		backgroundColor = backgroundColorByStatus.dispatcherBGC;
	} else if (item.executingStages?.assigned) {
		backgroundColor = backgroundColorByStatus.inactive;
	} else if (item.offer) {
		backgroundColor = item.offer.executor?.online
			? backgroundColorByStatus.offer
			: backgroundColorByStatus.inactive;
	}

	let textColor: string | undefined;

	if (isDispatcherFrom && lastReceivedOrder && isOwn) {
		textColor = undefined;
	} else if (
		isDispatcher &&
		(item.executingStages?.assigned || !item?.offer?.executor?.online)
	) {
		textColor = theme.colors.white;
	}

	return {
		content,
		backgroundColor,
		textColor,
	};
};

export default cellProcessing;
